import dbg from './Debug';
import {config} from './Config';
import app from './App';
import keyboard from './Keyboard';
import mouse from './Mouse';
import ui from './UI'
import translator from './Translator';
import navi from './Navi';
import scheduler from './Scheduler';
import util from './Util'


'use strict';

/**
 * Responsible for bootstrapping the application.
 *
 * @class Bootstrapper
 * @constructor
 * @module Core
 */
export class Bootstrapper {
    /**
     * Bootstraps the application.
     *
     * @method bootstrap
     */
    bootstrap(module) {
        var components = {
            _: _,
            $: $,
            config: config,
            dbg: dbg,
            keyboard: keyboard.init(),
            mouse: mouse.init(),
            ui: ui.init(),
            translator: translator,
            navi: navi,
            scheduler: scheduler.init(),
            util: util
        };

        app.module = module;

        module.config([
            '$provide', '$locationProvider', '$routeProvider',
            function ($provide, $locationProvider, $routeProvider) {
                app.provide = $provide;

                // listen for angular exceptions
                $provide.factory('$exceptionHandler', function () {
                    return function (exception) {
                        dbg.error(exception);
                        //console.error(exception);

                        return false;
                    };
                });

                // configure HTML5 url-rewrite mode
                $locationProvider
                    .html5Mode(true)
                    .hashPrefix('!');

                $RouteConfig.configure($routeProvider, config);
            }
        ]);


        // register callback for module run
        module.run(['$rootScope', '$location', '$route', '$routeParams', '$compile',
            ($rootScope, $location, $route, $routeParams, $compile) => {
                app.rootScope = $rootScope;
                app.location = $location;
                app.compile = $compile;

                navi.$location = $location;
                navi.$rootScope = $rootScope;
                navi.$route = $route;
                navi.$routeParams = $routeParams;

                navi.init();
            }]
        );

        // redraw the application when language changes
        components.translator.bind(components.translator.Event.LANGUAGE_CHANGED, ()=>app.validate());

        // listen for dom ready event
        $(document).ready(() => {
            // bootstrap the application, results in _onModuleRun below
            app.injector = angular.bootstrap($('HTML'), [app.module.name]);
        });
    }
}

export let bootstrapper = new Bootstrapper();



// WEBPACK FOOTER //
// ./src/main/ui/core/application/Bootstrapper.ts